import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, Sparkles, Zap, Heart } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: <Droplets className="w-8 h-8" data-id="element-1" />,
    title: 'Reduce Face Puffiness',
    description: 'Wake up with a visibly slimmer, more sculpted face as excess fluid drains away.'
  }, {
    icon: <Sparkles className="w-8 h-8" data-id="element-2" />,
    title: 'Release Water Retention',
    description: 'Feel lighter as trapped fluid gently drains away from your legs, ankles, and belly.'
  }, {
    icon: <Zap className="w-8 h-8" data-id="element-3" />,
    title: 'Support Natural Energy',
    description: 'Reclaim your vitality without jitters or crashes by clearing internal stagnation.'
  }, {
    icon: <Heart className="w-8 h-8" data-id="element-4" />,
    title: 'Promote Inner Vitality',
    description: "Nourish your body's natural detox pathways for a healthy, radiant glow."
  }];
  return <section className="py-24 bg-white" data-id="element-5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-7">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-8">
            <span className="text-[#10B981] font-bold uppercase tracking-wider text-sm" data-id="element-9">
              Proven Benefits
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1B5E20] mb-4 mt-2" data-id="element-10">
              See the Difference in How You{' '}
              <span className="text-[#10B981]" data-id="element-11">Look and Feel</span>
            </h2>
            <p className="text-lg text-[#374151]" data-id="element-12">
              Targeting the root cause of puffiness and fatigue for lasting
              results.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-13">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-8 rounded-2xl bg-gradient-to-br from-[#F0FFF4] to-white hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-[#10B981]/30" data-id="element-14">
              <div className="w-16 h-16 bg-[#10B981]/10 rounded-full flex items-center justify-center text-[#10B981] mb-6" data-id="element-15">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-[#1B5E20] mb-3" data-id="element-16">
                {benefit.title}
              </h3>
              <p className="text-[#374151] leading-relaxed" data-id="element-17">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}